import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { VideoSection } from '../components/VideoSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { FloorPlansSection } from '../components/FloorPlansSection';
import { CTABanner } from '../components/CTABanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  // Reset scroll on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-244">
      <Navbar data-id="element-245" />
      <main className="flex-grow" data-id="element-246">
        <HeroSection data-id="element-247" />
        <VideoSection data-id="element-248" />
        <FeaturesSection data-id="element-249" />
        <FloorPlansSection data-id="element-250" />
        <CTABanner data-id="element-251" />
      </main>
      <Footer data-id="element-252" />
    </div>;
}